import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  is_franchise_admin,
  is_franchise_manager,
  is_shop_admin,
  is_shop_manager,
  is_superuser,
  protocol,
} from "../../Functionalities/Config";
import {
  showMessage,
  formatTime,
  ManageProducts,
  getToken,
} from "../../Functionalities/Functions";
import {
  ManageFranchise,
  ManageBlock,
  ManageSettingsAdmin,
  ManageMinCartValue,
} from "./Logic";
import MapView from "./MapView";
import RestaurantAreaField from "./RestaurantAreaField";
import image from "../../Assets/images/profile_icon.jpg";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import EditTopComponent from "../../CoreComponents/EditTopComponent";
import EditBottomComponent from "../../CoreComponents/EditBottomComponent";
import FilterComponent from "../../CoreComponents/FilterComponent";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import { googleApiKey } from "../../Functionalities/Config";

function Body(props) {
  let id = props.restaurant;
  // const [adminEdit,setAdminEdit]=useState(false)
  const [loading, setLoading] = useState(true);
  const [edit, setEdit] = useState(false);
  const [commission, setCommission] = useState({
    franchise_id: "",
    commission: "",
  });
  const [minCartValue, setMinCartValue] = useState("");
  const [coordOb, setCoordObj] = useState({
    latitude: "",
    longitude: "",
    address: "",
  });
  const [restaurantCharge, setrestaurantCharge] = useState({
    charge: "",
    data_type: "",
    franchise_id: id,
    param_name: "restaurent_charge",
    keyword: "branch_configurations",
  });
  const [data, setData] = useState({
    id: "",
    name: "",
    "dual_name ": "",
    mobile: "",
    email: "",
    fssai: "",
    place: "",
    "latitude ": "",
    "longitude ": "",
    address: "",
    description: "",
    is_featured: false,
    images: [],
    manager: [],
    adminEdit: false,
    admin_id: "",
    admin_name: "",
    admin_username: "",
    admin_password: "",
    confirm_admin_password: "",
    admin_mobile: "",
    commission: "",
    opening_time: "",
    closing_time: "",
    is_block: false,
  });
  const [apiKey, setapiKey] = useState(null);
  const [producttsdata, setproducttsData] = useState({
    id: "",
    name: "",
    data: [],
  });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");

  const [swipe, setswipe] = useState(false);

  const [balance, setBalance] = useState({
    franchise_id: "",
    amount: "",
    mode_of_payment: "",
    discription: "",
  });

  useEffect(() => {
    getData();
    getApiKey();
    getMinCartValue();
  }, []);

  const handlePrev = () => {
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),

      // url: prev + "/?" + params,

      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setproducttsData({
          ...producttsdata,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      // url: "http://foodoorapi.codedady.com/items/details/?+my_branch=true&branch_id=1&for_dropdown=false&limit=12&offset=12",
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setproducttsData({
          ...producttsdata,
          data: response.data.results,
        });
        // void 0
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {});
  };
  const [nodata, setnodata] = useState(false);
  const getData = () => {
    let res = ManageFranchise("", "", "get", `id=${id}`);
    res.then((result) => {
      if (result.data.results && result.data.results.length) {
        setData({
          ...data,

          id: result.data.results[0].id,
          name: result.data.results[0].name,
          // dual_name: result.data.results[0].dual_name,
          mobile: result.data.results[0].mobile,
          franchise_email: result.data.results[0].franchise_email,

          place: result.data.results[0].place,
          latitude: result.data.results[0].latitude,
          longitude: result.data.results[0].longitude,
          description: result.data.results[0].description,
          address: result.data.results[0].address,
          is_blocked: result.data.results[0].is_blocked,
          commission: result.data.results[0].commission,
          restaurants_within_radius: result.data.results[0].restaurants_within_radius,

          manager: result.data.results[0].managers,

          // admin_name: "result.data.results[0].admin.first_name",
          // admin_username: "result.data.results[0].admin.username",
          // admin_password: "",
          // admin_id: "result.data.results[0].admin.id",
          admin_name: result.data.results[0].admin.first_name,
          admin_username: result.data.results[0].admin.username,
          admin_password: "",
          admin_id: result.data.results[0].admin.id,
          admin_email: result.data.results[0].admin.email,
          admin_mobile:
            result.data.results[0].admin.details &&
            result.data.results[0].admin.details.mobile,

          is_block: result.data.results[0].is_blocked,
        });
        setCommission({
          ...commission,
          franchise_id: result.data.results[0].id,
          commission: result.data.results[0].commission,
        });
        setBalance({ ...balance, franchise_id: result.data.results[0].id });
        setLoading(false);
        setCoordObj({
          latitude: result.data.results[0].latitude,
          longitude: result.data.results[0].longitude,
          address: result.data.results[0].address,
        });
      } else {
        setnodata(true);
        setLoading(false);
      }
      // void 0
    });
  };
  const getApiKey = () => {
    let res = ManageSettingsAdmin(
      "",
      "",
      "get",
      "param_name=googlemap_key&keyword=super_admin_conf",
    );
    res.then((result) => {
      if (
        result?.data?.Message?.param_value &&
        result.data.Message.param_value !== "XXXXXXXXXXXXXX"
      ) {
        setapiKey(result.data.Message.param_value);
      } else {
        setapiKey(null);
      }
      // void 0
    });
  };

  const getMinCartValue = () => {
    let params = `keyword=franchise_configurations&param_name=minimum_cart_value&franchise_id=${id}`;
    let result = ManageMinCartValue("", "", "get", params);
    result
      .then((res) => {
        if (res && res.data && res.data.Message) {
          setMinCartValue(res.data.Message.param_value);
        }
      })
      .catch((err) => {});
  };

  const updateMinCartValue = (e) => {
    e.preventDefault();
    if (minCartValue === "") {
      showMessage(
        "Please enter a minimum cart value",
        "danger",
        "Error!",
        "top",
        "top-right",
        0,
      );
      return;
    }
    const payload = [
      { key: "keyword", value: "franchise_configurations" },
      { key: "param_name", value: "minimum_cart_value" },
      { key: "new_param_value", value: String(minCartValue) },
      { key: "franchise_id", value: String(id) },
    ];
    let result = ManageMinCartValue(e, payload, "add");
    result
      .then((res) => {
        if (res && res.data && res.data.Status === true) {
          showMessage(
            "Minimum cart value updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
        } else {
          showMessage(
            "Minimum cart value update failed",
            "danger",
            "Error!",
            "top",
            "top-right",
            0,
          );
        }
      })
      .catch((err) => {
        showMessage(
          "Error updating minimum cart value",
          "danger",
          "Error!",
          "top",
          "top-right",
          0,
        );
      });
  };

  const [errors, setErrors] = useState([]);

  const handleCoordinatesChange = (latt, longi) => {
    setCoordObj((prev) => ({ ...prev, latitude: latt, longitude: longi }));
    setData((prev) => ({ ...prev, latitude: latt, longitude: longi }));
    let locToPlace = (lat, long) => {
      let url =
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        lat +
        "," +
        long +
        `&key=${apiKey ? apiKey : googleApiKey}&sensor=true`;
      axios
        .get(url)
        .then(function (response) {
          if (response.data.results && response.data.results.length > 0) {
            const address = response.data.results[0].formatted_address;
            setCoordObj((prev) => ({ ...prev, address }));
            setData((prev) => ({ ...prev, address }));
          }
        })
        .catch(function (error) {});
    };
    locToPlace(latt, longi);
  };

  useEffect(() => {
    if (errors.length > 0) {
      showMessage(
        errors[0],
        "danger",
        "Following fields required!",
        "top",
        "top-right",
        0,
      );
    }
  }, [errors]);
  // void 0

  return (
    <div className="content-body">
      <div className="container-fluid">
        {!loading ? (
          !nodata ? (
            <>
              <EditTopComponent
                swipe={swipe}
                page="Franchise"
                DeleteButton={(e) => {
                  e.preventDefault();
                  confirmAlert({
                    customUI: ({ onClose }) => {
                      return (
                        <div
                          className="custom-ui"
                          style={{
                            borderRadius: 8,
                            border: "solid",
                            padding: 70,
                            borderWidth: 0.5,
                          }}
                        >
                          <h1>Are you sure?</h1>
                          <p>You want to delete ?</p>
                          <button
                            onClick={onClose}
                            className="btn btn-primary"
                            style={{ marginRight: 10 }}
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => {
                              let res = ManageFranchise(
                                e,
                                "",
                                "delete",
                                `franchise_id=${data.id}`,
                              );
                              res
                                .then((res) => {
                                  // void 0
                                  if (res.data.Status === true) {
                                    //alert('success')
                                    showMessage(
                                      "Delete success",
                                      "success",
                                      "Success!",
                                      "top",
                                      "top-right",
                                    );
                                    window.location.replace("/franchises");
                                  } else {
                                    showMessage(
                                      res.data.Error,
                                      "danger",
                                      "Failed!",
                                      "top",
                                      "top-right",
                                    );
                                  }
                                })
                                .catch((err) => {
                                  showMessage(
                                    res.data.Error,
                                    "danger",
                                    "Error!",
                                    "top",
                                    "top-right",
                                  );
                                });
                            }}
                            className="btn btn-primary"
                          >
                            Delete
                          </button>
                        </div>
                      );
                    },
                  });
                }}
                // AddButtonName={"Add Restaurant"}
                // AddButtonPath={"/addrestaurant"}
                CancelButton={(e) => {
                  e.preventDefault();
                  setEdit(false);
                  // void 0
                }}
                EditButton={(e) => {
                  e.preventDefault();
                  setEdit(true);
                  // void 0
                }}
                Edit={edit}
              />

              {swipe ? (
                <div className="container-fluid">
                  <FilterComponent
                    handleNext={handleNext}
                    handlePrev={handlePrev}
                    next={next}
                    prev={prev}
                    addItemName={"Add Products"}
                    addItemPath={"/addproducts"}
                  />
                </div>
              ) : edit ? (
                <>
                  <div className="col-xl-12 col-lg-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="basic-form">
                          <form>
                            {is_superuser && data.adminEdit ? (
                              <>
                                <div className="card-header">
                                  <h4 className="card-title">
                                    Edit Admin Section
                                  </h4>
                                </div>
                                <div className="card-body">
                                  <div className="basic-form">
                                    <div className="form-row">
                                      <div className="form-group col-md-6">
                                        <label>
                                          Name{" "}
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={data.admin_name}
                                          onChange={(e) => {
                                            setData({
                                              ...data,
                                              admin_name: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                      <div className="form-group col-md-6">
                                        <label>
                                          Username{" "}
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={data.admin_username}
                                          onChange={(e) => {
                                            setData({
                                              ...data,
                                              admin_username: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>

                                      <div className="form-group col-md-6">
                                        <label>Password</label>
                                        <input
                                          type="password"
                                          className="form-control"
                                          value={data.admin_password}
                                          onChange={(e) => {
                                            setData({
                                              ...data,
                                              admin_password: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                      {data.admin_password && (
                                        <div className="form-group col-md-6">
                                          <label>
                                            Confirm Password{" "}
                                            <span className="required">*</span>
                                          </label>
                                          <input
                                            type="password"
                                            className="form-control"
                                            value={data.confirm_admin_password}
                                            onChange={(e) => {
                                              setData({
                                                ...data,
                                                confirm_admin_password:
                                                  e.target.value,
                                              });
                                            }}
                                          />
                                        </div>
                                      )}
                                      <div className="form-group col-md-6">
                                        <label>
                                          Mobile{" "}
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="number"
                                          min={0}
                                          className="form-control"
                                          onKeyDown={(evt) =>
                                            ((evt.key === "e" ||
                                              evt.key === "-") &&
                                              evt.preventDefault()) ||
                                            (evt.key === "E" &&
                                              evt.preventDefault())
                                          }
                                          onWheelCapture={(e) => {
                                            e.target.blur();
                                          }}
                                          value={data.admin_mobile}
                                          onChange={(e) => {
                                            setData({
                                              ...data,
                                              admin_mobile:
                                                e.target.value.slice(0, 10),
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                {is_superuser && (
                                  <div className="text-right">
                                    <a
                                      href="javascript:void()"
                                      className="btn btn-primary mb-1"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setData({ ...data, adminEdit: true });
                                      }}
                                    >
                                      Admin Edit
                                    </a>
                                  </div>
                                )}
                              </>
                            )}
                            <div className="card-header">
                              <h4 className="card-title">
                                Edit Franchise Details
                              </h4>
                            </div>
                            <br></br>
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Franchise name{" "}
                                <span className="required">*</span>
                              </label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={data.name}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      name: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>

                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Mobile <span className="required">*</span>
                              </label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  onKeyDown={(evt) =>
                                    ((evt.key === "e" || evt.key === "-") &&
                                      evt.preventDefault()) ||
                                    (evt.key === "E" && evt.preventDefault())
                                  }
                                  onWheelCapture={(e) => {
                                    e.target.blur();
                                  }}
                                  value={data.mobile}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      mobile: e.target.value.slice(0, 10),
                                    })
                                  }
                                />
                              </div>
                            </div>

                            <div className="form-group row">
                              <label className="col-sm-4 col-form-label">
                                Location <span className="required">*</span>
                              </label>
                            </div>

                            {void 0}

                            {apiKey !== null ? (
                              <div
                                style={{
                                  marginBottom: 20,
                                  border: "1px solid #69ff76",
                                  padding: 10,
                                  borderRadius: 20,
                                }}
                              >
                                <MapView
                                  onChange={handleCoordinatesChange}
                                  coordinates={{
                                    lat: parseFloat(coordOb.latitude),
                                    lng: parseFloat(coordOb.longitude),
                                  }}
                                />
                              </div>
                            ) : (
                              <div>
                                <div class="form-group row">
                                  <label className="col-sm-3 col-form-label">
                                    Latitude
                                  </label>
                                  <div class="col-sm-9">
                                    <input
                                      type="number"
                                      className="form-control"
                                      required
                                      value={data.latitude}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          latitude: e.target.value,
                                        })
                                      }
                                    ></input>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label className="col-sm-3 col-form-label">
                                    Longitude
                                  </label>
                                  <div class="col-sm-9">
                                    <input
                                      type="number"
                                      className="form-control"
                                      required
                                      value={data.longitude}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          longitude: e.target.value,
                                        })
                                      }
                                    ></input>
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Address <span className="required"></span>
                              </label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={coordOb.address}
                                  onChange={(e) =>
                                    setCoordObj({
                                      ...coordOb,
                                      address: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>

                            <div class="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Description
                                {/* <span className="required">*</span> */}
                              </label>
                              <div class="col-sm-9">
                                <textarea
                                  class="form-control"
                                  rows="4"
                                  id="comment"
                                  value={data.description}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      description: e.target.value,
                                    })
                                  }
                                ></textarea>
                              </div>
                            </div>
                            {is_superuser && (
                              <RestaurantAreaField
                                value={data.restaurants_within_radius}
                                onChange={(restaurants_within_radius) =>
                                  setData({ ...data, restaurants_within_radius })
                                }
                              />
                            )}
                            <br />

                            {is_superuser ? (
                              data.adminEdit ? (
                                <EditBottomComponent
                                  cancelButton={(e) => {
                                    e.preventDefault();
                                    setEdit(false);
                                  }}
                                  saveButton={(e) => {
                                    e.preventDefault();
                                    // void 0
                                    setErrors([]);
                                    if (
                                      data.admin_name === "" ||
                                      data.admin_name === null
                                    ) {
                                      setErrors(["Admin name"]);
                                      return;
                                    }

                                    if (
                                      data.admin_username === "" ||
                                      data.admin_username === null
                                    ) {
                                      setErrors(["Admin username"]);
                                      return;
                                    }

                                    if (
                                      data.admin_mobile === "" ||
                                      data.admin_mobile === null
                                    ) {
                                      setErrors(["Admin mobile"]);
                                      return;
                                    }

                                    if (data.admin_mobile.length < 10) {
                                      setErrors([
                                        "Admin mobile is less than 10 numbers",
                                      ]);
                                      return;
                                    }
                                    // if (data.email === "") {
                                    //     setErrors([" Email"])
                                    //     return
                                    // }
                                    if (
                                      data.admin_password !==
                                      data.confirm_admin_password
                                    ) {
                                      setErrors(["Admin passwords not match"]);
                                      return;
                                    }

                                    if (
                                      data.name === "" ||
                                      data.name === null
                                    ) {
                                      setErrors(["Franchise name"]);
                                      return;
                                    }
                                    // void 0
                                    if (
                                      data.mobile === "" ||
                                      data.mobile === null
                                    ) {
                                      setErrors(["Franchise mobile"]);
                                      return;
                                    }
                                    if (data.mobile.length < 10) {
                                      setErrors([
                                        "Franchise mobile is less than 10 digits",
                                      ]);
                                      return;
                                    }

                                    if (
                                      data.latitude === "" ||
                                      data.latitude === null
                                    ) {
                                      setErrors([
                                        "Please choose a location on map",
                                      ]);
                                      return;
                                    }
                                    if (
                                      data.longitude === "" ||
                                      data.longitude === null
                                    ) {
                                      setErrors([
                                        "Please choose a location on map",
                                      ]);
                                      return;
                                    }
                                    if (data.mobile.length < 10) {
                                      setErrors(["Franchise mobile invalid"]);
                                      return;
                                    }

                                    // if (data.description === "") {
                                    //     setErrors(["Description"])
                                    //     return
                                    // }
                                    // alert("3")
                                    // return
                                    let res = ManageFranchise(
                                      e,
                                      data,
                                      "update",
                                      "",
                                    );
                                    res.then((res) => {
                                      if (res.data.Status === true) {
                                        showMessage(
                                          "Franchise successfully updated",
                                          "success",
                                          "Success!",
                                          "top",
                                          "top-right",
                                          0,
                                        );
                                      } else {
                                        // showMessage(res.data.Error, "danger", "Restaurant update error", "top", "top-right", 0)
                                        if (res.data.Status === false) {
                                          showMessage(
                                            res.data.Message,
                                            "danger",
                                            res.data.Error,
                                            "top",
                                            "top-right",
                                            0,
                                          );

                                          // showMessage("Something went wrong", "danger", "Franchise update error", "top", "top-right", 0)
                                        } else {
                                          showMessage(
                                            "Something went wrong",
                                            "danger",
                                            "Franchise update error",
                                            "top",
                                            "top-right",
                                            0,
                                          );
                                        }
                                      }
                                    });
                                  }}
                                />
                              ) : (
                                <EditBottomComponent
                                  cancelButton={(e) => {
                                    e.preventDefault();
                                    setEdit(false);
                                  }}
                                  saveButton={(e) => {
                                    e.preventDefault();

                                    // void 0

                                    // void 0
                                    setErrors([]);

                                    // if (data.place === "") {
                                    //     setErrors(["Franchise place"])
                                    //     return
                                    // }

                                    if (
                                      data.name === "" ||
                                      data.name === null
                                    ) {
                                      setErrors(["Franchise name"]);
                                      return;
                                    }
                                    // void 0
                                    if (
                                      data.mobile === "" ||
                                      data.mobile === null
                                    ) {
                                      setErrors(["Franchise mobile"]);
                                      return;
                                    }

                                    // if (data.place === "") {
                                    //     setErrors(["Restaurant place"])
                                    //     return
                                    // }
                                    if (
                                      data.latitude === "" ||
                                      data.latitude === null
                                    ) {
                                      setErrors([
                                        "Please choose a location on map",
                                      ]);
                                      return;
                                    }
                                    if (
                                      data.longitude === "" ||
                                      data.longitude === null
                                    ) {
                                      setErrors([
                                        "Please choose a location on map",
                                      ]);
                                      return;
                                    }
                                    // alert("1")
                                    // return
                                    let res = ManageFranchise(
                                      e,
                                      data,
                                      "update",
                                      "",
                                    );
                                    res.then((res) => {
                                      if (res) {
                                        if (res.data.Status === true) {
                                          showMessage(
                                            "Franchise successfully updated",
                                            "success",
                                            "Success!",
                                            "top",
                                            "top-right",
                                            0,
                                          );
                                        } else {
                                          showMessage(
                                            res.data.Error,
                                            "danger",
                                            "Franchise update error",
                                            "top",
                                            "top-right",
                                            0,
                                          );
                                        }
                                      } else {
                                        showMessage(
                                          "error",
                                          "danger",
                                          "Franchise update error",
                                          "top",
                                          "top-right",
                                          0,
                                        );
                                      }
                                    });
                                  }}
                                />
                              )
                            ) : (
                              <EditBottomComponent
                                cancelButton={(e) => {
                                  e.preventDefault();
                                  setEdit(false);
                                }}
                                saveButton={(e) => {
                                  e.preventDefault();
                                  // void 0

                                  // void 0
                                  setErrors([]);

                                  if (data.name === "" || data.name === null) {
                                    setErrors(["Franchise name"]);
                                    return;
                                  }
                                  // void 0
                                  if (
                                    data.mobile === "" ||
                                    data.mobile === null
                                  ) {
                                    setErrors(["Franchise mobile"]);
                                    return;
                                  }

                                  if (
                                    data.latitude === "" ||
                                    data.latitude === null
                                  ) {
                                    setErrors([
                                      "Please choose a location on map",
                                    ]);
                                    return;
                                  }
                                  if (
                                    data.longitude === "" ||
                                    data.longitude === null
                                  ) {
                                    setErrors([
                                      "Please choose a location on map",
                                    ]);
                                    return;
                                  }
                                  // if (data.address === ""|| data.address === null) {
                                  //     setErrors(["Please choose a location on map"])
                                  //     return
                                  // }
                                  // if (data.description === "") {
                                  //     setErrors(["Description"])
                                  //     return
                                  // }

                                  // alert("2")
                                  // return

                                  let res = ManageFranchise(
                                    e,
                                    {
                                      ...data,
                                      address: coordOb.address,
                                      latitude: coordOb.latitude,
                                      longitude: coordOb.longitude,
                                    },
                                    "update",
                                    "",
                                  );
                                  res.then((res) => {
                                    if (res) {
                                      if (res.data.Status === true) {
                                        showMessage(
                                          "Franchise successfully updated",
                                          "success",
                                          "Success!",
                                          "top",
                                          "top-right",
                                          0,
                                        );
                                      } else {
                                        showMessage(
                                          res.data.Error,
                                          "danger",
                                          "Franchise update error",
                                          "top",
                                          "top-right",
                                          0,
                                        );
                                      }
                                    } else {
                                      showMessage(
                                        "error",
                                        "danger",
                                        "Franchise update error",
                                        "top",
                                        "top-right",
                                        0,
                                      );
                                    }
                                  });
                                }}
                              />
                            )}
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                data.id && (
                  <>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="profile card card-body px-3 pt-3 pb-0">
                          <div className="profile-head">
                            <div className="photo-content">
                              <div
                                className="cover-photo"
                                style={{
                                  borderRadius: 14,
                                  backgroundImage:
                                    data.images.length > 0 &&
                                    data.images[0].image,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "white",
                                  flexDirection: "column",
                                }}
                              >
                                <h3
                                  style={{
                                    display: "flex",
                                    color: "white",
                                    cursor: "pointer",
                                  }}
                                  title={`${data.id} : ${data.name}`}
                                >
                                  {data.name}
                                </h3>
                                {/* <br/> */}
                                <h6 style={{ display: "flex", color: "white" }}>
                                  {data.description}
                                </h6>
                              </div>
                            </div>
                            <div className="profile-info">
                              <div className="profile-photo">
                                <img
                                  src={
                                    data.images.length > 0 &&
                                    data.images[0].image
                                  }
                                  className="img-fluid rounded-circle"
                                  alt
                                />
                              </div>
                              <div className="profile-details">
                                <div className="profile-name px-3 pt-2">
                                  {is_franchise_admin ? (
                                    <>
                                      <a href={`/profile`}>
                                        <b className="text-primary mb-0">
                                          {data.admin_name}
                                        </b>
                                      </a>
                                      <br />

                                      <a href={`/profile`}>
                                        <p className="text-primary mb-0">
                                          {data.admin_username}
                                        </p>
                                      </a>
                                    </>
                                  ) : (
                                    <>
                                      <div>
                                        <b className="text-primary mb-0">
                                          {data.admin_name}
                                        </b>
                                      </div>
                                      <br />

                                      <div>
                                        <p className="text-primary mb-0">
                                          {data.admin_username}
                                        </p>
                                      </div>
                                    </>
                                  )}
                                  <p>Admin</p>
                                </div>
                              </div>

                              <div className="profile-details">
                                <div className="profile-name px-3 pt-2">
                                  <a href="">
                                    <h4 className="text-primary mb-0">
                                      {formatTime(data.opening_time)}
                                    </h4>
                                  </a>
                                  <p>Opening Time</p>
                                </div>
                                <div className="profile-name px-3 pt-2 mr-4">
                                  <a href="">
                                    <h4 className="text-primary mb-0">
                                      {formatTime(data.closing_time)}
                                    </h4>
                                  </a>
                                  <p>Closing Time</p>
                                </div>
                                {is_superuser && (
                                  <div className="profile-name mt-2 mr-2">
                                    <a
                                      class="btn btn-primary"
                                      href={`/setting/${data.id}`}
                                    >
                                      <i class="fa fa-edit"></i>Settings
                                    </a>
                                  </div>
                                )}
                                {is_superuser &&
                                  (data.is_block ? (
                                    <div className="profile-name mt-2">
                                      <div
                                        class="btn btn-primary"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          confirmAlert({
                                            customUI: ({ onClose }) => {
                                              return (
                                                <div
                                                  className="custom-ui"
                                                  style={{
                                                    borderRadius: 8,
                                                    border: "solid",
                                                    padding: 70,
                                                    borderWidth: 0.5,
                                                  }}
                                                >
                                                  <h1>Are you sure?</h1>
                                                  <p>You want to Unblock ?</p>
                                                  <button
                                                    onClick={onClose}
                                                    className="btn btn-primary"
                                                    style={{ marginRight: 10 }}
                                                  >
                                                    Cancel
                                                  </button>
                                                  <button
                                                    onClick={() => {
                                                      setData({
                                                        ...data,
                                                        is_block: false,
                                                      });
                                                      var data1 = {
                                                        ...data,
                                                        is_block: false,
                                                      };
                                                      let result = ManageBlock(
                                                        e,
                                                        data1,
                                                        "patch",
                                                        "",
                                                      );
                                                      result
                                                        .then((result) => {
                                                          if (
                                                            result.data
                                                              .Status === true
                                                          ) {
                                                            showMessage(
                                                              " Unblock success",
                                                              "success",
                                                              "Success!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                            window.location.reload();
                                                          } else {
                                                            showMessage(
                                                              " Unblock failed",
                                                              "danger",
                                                              "Failed!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                            // window.location.reload()
                                                          }
                                                        })
                                                        .catch((err) => {
                                                          showMessage(
                                                            "failed",
                                                            "danger",
                                                            "Error!",
                                                            "top",
                                                            "top-right",
                                                          );
                                                        });
                                                    }}
                                                    className="btn btn-primary"
                                                  >
                                                    Unblock
                                                  </button>
                                                </div>
                                              );
                                            },
                                          });
                                        }}
                                      >
                                        <i class="fa fa-ban"></i> Unblock
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="profile-name mt-2">
                                      <div
                                        class="btn btn-primary"
                                        onClick={(e) => {
                                          e.preventDefault();

                                          confirmAlert({
                                            customUI: ({ onClose }) => {
                                              return (
                                                <div
                                                  className="custom-ui"
                                                  style={{
                                                    borderRadius: 8,
                                                    border: "solid",
                                                    padding: 70,
                                                    borderWidth: 0.5,
                                                  }}
                                                >
                                                  <h1>Are you sure?</h1>
                                                  <p>You want to Block ?</p>
                                                  <button
                                                    onClick={onClose}
                                                    className="btn btn-primary"
                                                    style={{ marginRight: 10 }}
                                                  >
                                                    Cancel
                                                  </button>
                                                  <button
                                                    onClick={() => {
                                                      setData({
                                                        ...data,
                                                        is_block: true,
                                                      });
                                                      var data1 = {
                                                        ...data,
                                                        is_block: true,
                                                      };
                                                      let result = ManageBlock(
                                                        e,
                                                        data1,
                                                        "patch",
                                                        "",
                                                      );
                                                      result
                                                        .then((result) => {
                                                          // return

                                                          if (
                                                            result.data
                                                              .Status === true
                                                          ) {
                                                            showMessage(
                                                              " Block success",
                                                              "success",
                                                              "Success!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                            window.location.reload();
                                                          } else {
                                                            showMessage(
                                                              " Block failed",
                                                              "danger",
                                                              "Failed!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                            window.location.reload();
                                                          }
                                                        })
                                                        .catch((err) => {
                                                          showMessage(
                                                            "failed",
                                                            "danger",
                                                            "Error!",
                                                            "top",
                                                            "top-right",
                                                          );
                                                        });
                                                    }}
                                                    className="btn btn-primary"
                                                  >
                                                    Block
                                                  </button>
                                                </div>
                                              );
                                            },
                                          });
                                        }}
                                      >
                                        <i class="fa fa-ban"></i> Block
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-6">
                        <div
                          style={{ backgroundColor: "white", borderRadius: 20 }}
                        >
                          {/* commission percentage */}

                          <div
                            style={{
                              backgroundColor: "white",
                              borderRadius: 20,
                            }}
                          >
                            <div className="card-header d-sm-flex flex-wrap d-block pb-0 border-0">
                              <div className="mr-auto pr-3">
                                <h4 className="text-black fs-20">
                                  Commission Percentage
                                </h4>
                              </div>
                            </div>
                            <div className="card-body">
                              <div className="basic-form mb-2">
                                <form action="#">
                                  <div className="input-group ">
                                    <div className="dropdown bootstrap-select default-select">
                                      <input
                                        type="number"
                                        min={0}
                                        className="form-control"
                                        disabled={!is_superuser}
                                        placeholder="Commission"
                                        onWheelCapture={(e) => {
                                          e.target.blur();
                                        }}
                                        onKeyDown={(evt) =>
                                          ((evt.key === "e" ||
                                            evt.key === "-" ||
                                            evt.key === "+") &&
                                            evt.preventDefault()) ||
                                          (evt.key === "E" &&
                                            evt.preventDefault())
                                        }
                                        value={commission.commission}
                                        onChange={(e) => {
                                          setCommission({
                                            ...commission,
                                            commission: e.target.value,
                                          });
                                        }}
                                      />
                                    </div>
                                    <div className="ml-4">
                                      {is_superuser && (
                                        <button
                                          type="submit"
                                          className="btn btn-primary"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            if (commission.commission === "") {
                                              showMessage(
                                                "Please enter a commission percentage",
                                                "danger",
                                                "Error!",
                                                "top",
                                                "top-right",
                                                0,
                                              );
                                              return;
                                            }

                                            let result = ManageFranchise(
                                              e,
                                              commission,
                                              "patch",
                                            );
                                            result
                                              .then((result) => {
                                                // return
                                                if (
                                                  result.data.Status === true
                                                ) {
                                                  // alert('success')
                                                  showMessage(
                                                    "Commission updated",
                                                    "success",
                                                    "Success!",
                                                    "top",
                                                    "top-right",
                                                    0,
                                                  );
                                                } else {
                                                  showMessage(
                                                    "Commission update failed",
                                                    "danger",
                                                    "Error!",
                                                    "top",
                                                    "top-right",
                                                    0,
                                                  );
                                                }
                                              })
                                              .catch((err) => {
                                                showMessage(
                                                  "Error",
                                                  "danger",
                                                  "Error!",
                                                  "top",
                                                  "top-right",
                                                  0,
                                                );
                                              });
                                          }}
                                        >
                                          {" "}
                                          Submit
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            backgroundColor: "white",
                            borderRadius: 20,
                            marginTop: 20,
                          }}
                        >
                          <div className="card-header d-sm-flex flex-wrap d-block pb-0 border-0">
                            <div className="mr-auto pr-3">
                              <h4 className="text-black fs-20">
                                Minimum Cart Value
                              </h4>
                            </div>
                          </div>
                          <div className="card-body">
                            <div className="basic-form mb-2">
                              <form action="#">
                                <div className="input-group">
                                  <div className="dropdown bootstrap-select default-select">
                                    <input
                                      type="number"
                                      min={0}
                                      className="form-control"
                                      disabled={!is_superuser}
                                      placeholder="Min Cart Value"
                                      onWheelCapture={(e) => {
                                        e.target.blur();
                                      }}
                                      onKeyDown={(evt) =>
                                        ((evt.key === "e" ||
                                          evt.key === "-" ||
                                          evt.key === "+") &&
                                          evt.preventDefault()) ||
                                        (evt.key === "E" &&
                                          evt.preventDefault())
                                      }
                                      value={minCartValue}
                                      onChange={(e) => {
                                        setMinCartValue(e.target.value);
                                      }}
                                    />
                                  </div>
                                  <div className="ml-4">
                                    {is_superuser && (
                                      <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={updateMinCartValue}
                                      >
                                        Submit
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6">
                        <div className="card">
                          <div className="card-body">
                            <div className="profile-statistics mb-5">
                              <div className="row text-left">
                                <div className="col">
                                  <span>Franchise</span>
                                  <h4 className="m-b-0">{data.name}</h4>
                                </div>
                                <div className="col">
                                  <span>Commission</span>
                                  <h4 className="m-b-0">
                                    {commission.commission}
                                  </h4>
                                </div>
                                <div className="col">
                                  <span>Min Cart Value</span>
                                  <h4 className="m-b-0">
                                    {minCartValue || "Not Set"}
                                  </h4>
                                </div>
                              </div>
                              <br />
                              <div className="row text-left">
                                <div className="col">
                                  <span>Mobile</span>
                                  <h4 className="m-b-0">{data.mobile}</h4>
                                </div>
                                <div className="col">
                                  <span>Address</span>
                                  <h4 className="m-b-0">{data.address}</h4>
                                </div>
                              </div>
                              <br />
                              {/* <div className="row text-left">
                                                                    <div className="col">
                                                                        <span>Address</span>
                                                                        <h4 className="m-b-0">{data.address}</h4>
                                                                    </div>
                                                                </div> */}
                            </div>

                            <div className="profile-blog mb-5"></div>

                            <div className="profile-news">
                              <div className="row">
                                <div className="col text-left">
                                  <h5 className="text-primary d-inline ">
                                    Our Managers -{" "}
                                    {data.manager.length <= 0 &&
                                      "Currently no managers created"}
                                  </h5>
                                </div>
                                {/* || is_franchise_staff */}
                                {(is_franchise_admin ||
                                  is_franchise_manager) && (
                                  <div className="col text-right">
                                    <button
                                      type="submit"
                                      className="btn btn-primary "
                                      onClick={(e) => {
                                        e.preventDefault();
                                        window.location.replace("/addmanager/");
                                      }}
                                    >
                                      Add manager
                                    </button>
                                  </div>
                                )}
                              </div>
                              {data.manager.length > 0 &&
                                data.manager.map((man) => {
                                  return (
                                    <div className="media pt-3 pb-3">
                                      <img
                                        className="mr-3 img-fluid btn-rounded"
                                        width={55}
                                        height={55}
                                        src={image}
                                        alt="Foodoor"
                                      />
                                      <div className="media-body">
                                        <h5 className="m-b-5">
                                          <a
                                            href={
                                              is_shop_admin
                                                ? `/manager/${man.id}`
                                                : is_shop_manager
                                                  ? ""
                                                  : is_superuser &&
                                                    `/resetPassword/${man.id}`
                                            }
                                            className="text-black"
                                          >
                                            {man.first_name}
                                          </a>
                                        </h5>
                                        <p className="mb-0">{man.email}</p>

                                        <p className="mb-0">
                                          {man.details.mobile}
                                        </p>
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )
              )}
            </>
          ) : (
            <NoDataComponent data="Franchise" />
          )
        ) : (
          <LoadingComponent />
        )}
      </div>
    </div>
  );
}

function Franchise() {
  const headers = "Franchise Details";
  let { id } = useParams();

  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        <Body restaurant={id} />
        <Footer />
      </div>
    </div>
  );
}

export default Franchise;
